import uuid from "uuid";

import { FileUpload } from "@examspark/types";

/**
 * Wrapper method for calculating the proper upload file paths to S3 based on
 * workspace ID, current time, etc., and then invoking an injected upload
 * method. You must supply the actual upload method.
 */
export const uploadFileAsResource = async <T>(
  file: FileUpload,
  workspaceId: string,
  uploadFn: (key: string, file: File) => T,
) => {
  const resourceId = uuid();
  const [year, month, day] = new Date().toISOString().slice(0, 10).split("-");
  const fileName = file.file.name;
  const fileKey = [
    "workspace",
    workspaceId,
    "resources",
    year,
    [month, day].join(""),
    resourceId,
    fileName,
  ].join("/");

  const upload = await uploadFn(fileKey, file.file);

  return {
    id: resourceId,
    ...upload,
  };
};
